import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SplitOpsOrderMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  containers?: Types.InputMaybe<Array<Types.OpsOrderSplitContainerInput> | Types.OpsOrderSplitContainerInput>;
  untracked_items?: Types.InputMaybe<Array<Types.OpsOrderSplitUntrackedItemInput> | Types.OpsOrderSplitUntrackedItemInput>;
  items?: Types.InputMaybe<Array<Types.OpsOrderSplitItemInput> | Types.OpsOrderSplitItemInput>;
}>;


export type SplitOpsOrderMutation = { __typename?: 'Mutation', splitOpsOrder: string };


export const SplitOpsOrderDocument = gql`
    mutation SplitOpsOrder($id: ID!, $containers: [OpsOrderSplitContainerInput!], $untracked_items: [OpsOrderSplitUntrackedItemInput!], $items: [OpsOrderSplitItemInput!]) {
  splitOpsOrder(
    id: $id
    containers: $containers
    untracked_items: $untracked_items
    items: $items
  )
}
    `;
export type SplitOpsOrderMutationFn = Apollo.MutationFunction<SplitOpsOrderMutation, SplitOpsOrderMutationVariables>;

/**
 * __useSplitOpsOrderMutation__
 *
 * To run a mutation, you first call `useSplitOpsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitOpsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitOpsOrderMutation, { data, loading, error }] = useSplitOpsOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      containers: // value for 'containers'
 *      untracked_items: // value for 'untracked_items'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useSplitOpsOrderMutation(baseOptions?: Apollo.MutationHookOptions<SplitOpsOrderMutation, SplitOpsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitOpsOrderMutation, SplitOpsOrderMutationVariables>(SplitOpsOrderDocument, options);
      }
export type SplitOpsOrderMutationHookResult = ReturnType<typeof useSplitOpsOrderMutation>;
export type SplitOpsOrderMutationResult = Apollo.MutationResult<SplitOpsOrderMutation>;
export type SplitOpsOrderMutationOptions = Apollo.BaseMutationOptions<SplitOpsOrderMutation, SplitOpsOrderMutationVariables>;